import { Typography } from '@material-ui/core'
import i18n from 'i18next'
import Link from 'next/link'
import { Fragment } from 'react'

export function Breadcumb({ offer }) {
  return (
    <Typography variant="h2">
      {offer && (
        <Fragment>
          <small>
            <Link href={`/entreprise/profile/offres`}>
              <a>{i18n.t('profile.entreprise.application.offer')}</a>
            </Link>
            {' \\ '}
            <Link href={`/job-offer/${offer.hashid}`}>
              <a>{offer.label}</a>
            </Link>
          </small>
        </Fragment>
      )}
    </Typography>
  )
}
